import React from 'react';
import { Paper, Grid, Typography, Button, Chip, Box } from '@mui/material';
import {
  Add as AddIcon,
  Compare as CompareIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * TemplateInfoCard Component
 * Displays template information and action buttons
 */
const TemplateInfoCard = ({
  template,
  templateId,
  comparisonMode,
  selectedVersions,
  onCreateNewVersion,
  onToggleComparison,
}) => {
  const navigate = useNavigate();

  if (!template) return null;

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, md: 8 }}>
          <Typography variant="h6" gutterBottom>
            {template.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            {template.description || 'No description provided'}
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            <Chip
              label={template.category}
              size="small"
              color="primary"
              variant="outlined"
              sx={{
                pl: 3,
                pr: 3,
                py: 0.25,
                '& .MuiChip-label': {
                  px: 2,
                  maxWidth: 'none',
                  whiteSpace: 'nowrap',
                  overflow: 'visible',
                  textOverflow: 'clip',
                },
              }}
            />
            <Chip
              label={template.output_format}
              size="small"
              color="secondary"
              variant="outlined"
            />
            <Chip label={`v${template.version}`} size="small" color="info" />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }} textAlign="right">
          <Box display="flex" flexDirection="column" gap={1}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onCreateNewVersion}
              fullWidth
            >
              Create New Version
            </Button>
            <Button
              variant="outlined"
              startIcon={<CompareIcon />}
              onClick={onToggleComparison}
              disabled={selectedVersions.length !== 2}
              fullWidth
            >
              Compare Versions
            </Button>
            {templateId && (
              <Button
                variant="outlined"
                startIcon={<SecurityIcon />}
                onClick={() =>
                  navigate(`/templates/${templateId}/content-check`)
                }
                fullWidth
                color="secondary"
              >
                Manage Content Check Policies
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TemplateInfoCard;
